import { render, staticRenderFns } from "./SexagesimalFormatTable.vue?vue&type=template&id=fea35f18&scoped=true"
import script from "./SexagesimalFormatTable.vue?vue&type=script&lang=ts"
export * from "./SexagesimalFormatTable.vue?vue&type=script&lang=ts"
import style0 from "./SexagesimalFormatTable.vue?vue&type=style&index=0&id=fea35f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea35f18",
  null
  
)

export default component.exports